export default "__VITE_ASSET__DAjeIO18__"